<template>
    <div class="mt-8 md:mt-0">
        <div class="absolute -mt-1 md:-mt-3 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-equals"></i>
        </div>

        <form-row title="Balance Needed to Close"
            :no_border="true"
            class="mt-4"
            label_class="ml-8 md:ml-0 md:mt-6"
        >
            <div class="flex flex-col flex-1 sm:flex-row sm:items-end">
                <input-money
                    name="balance_needed_to_close"
                    :value="value"
                    :read_only="true"
                />

                <input-text
                    class="mt-4 sm:mt-0 sm:ml-4 flex-1"
                    label="Source of funds"
                    name="balance_needed_to_close_source"
                    :value="mortgage.balance_needed_to_close_source"
                    :read_only="read_only"
                />
            </div>
        </form-row>

        <p class="sm:ml-46 text-gray-warm-800 text-sm mt-5">
            Note: This is an estimate and may vary due to closing costs and closing credits.
        </p>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        mortgage: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
